import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NotesComponent } from './notes.component';
import { NotesService } from '../../services/notes.service';
import { NotesRoutingModule } from './notes-routing.module';
import { NoteMainModule } from './note-main/note-main.module';
import { NoteViewerModule } from './note-viewer/note-viewer.module';
import { NoteBuilderModule } from './note-builder/note-builder.module';
import { NoteBoilerplateModule } from './note-boilerplates/note-boilerplates.module';
import { NoteExampleModule } from './note-example/note-examplemodule';
import { NoteCompactV2Module } from './note-compact-v2/note-compact-v2.module';
import { _testNotesGlobals } from './models/Notes.models';

// material
import { MatSnackBarModule } from '@angular/material/snack-bar';


@NgModule({
  declarations: [
    NotesComponent,
    ],
  imports: [
    CommonModule,
    FormsModule,

    NotesRoutingModule,
    NoteMainModule,
    NoteViewerModule,
    NoteBuilderModule,
    NoteBoilerplateModule,
    NoteCompactV2Module,
    NoteExampleModule,

    // material
    MatSnackBarModule,
  ],
  exports: [
    NotesComponent,
    NoteMainModule
  ],
  providers: [
    NotesService,
    _testNotesGlobals,
  ]
})
export class NotesModule { }
